/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sklik_InactiveInputs */

const cs_sklik_inactive = /** @type {(inputs: Sklik_InactiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pozastaveno`)
};

const en_sklik_inactive = /** @type {(inputs: Sklik_InactiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paused`)
};

/**
* | output |
* | --- |
* | "Paused" |
*
* @param {Sklik_InactiveInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sklik_inactive = /** @type {((inputs?: Sklik_InactiveInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sklik_InactiveInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sklik_inactive(inputs)
	return cs_sklik_inactive(inputs)
});